import { render, staticRenderFns } from "./uCountDown.vue?vue&type=template&id=0524d3f3&scoped=true"
import script from "./uCountDown.vue?vue&type=script&lang=js"
export * from "./uCountDown.vue?vue&type=script&lang=js"
import style0 from "./uCountDown.vue?vue&type=style&index=0&id=0524d3f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524d3f3",
  null
  
)

export default component.exports